import { useCallback } from 'react';
import { Masonry } from '@leagueplatform/masonry';
import { useIntl } from '@leagueplatform/locales';
import { usePageViewAnalytics } from '@leagueplatform/analytics';
import { useDocumentTitle } from '@leagueplatform/web-common';
import { MASONRY } from 'common/constants';
import { OnboardingCard } from 'components/onboarding/onboarding-card/onboarding-card.component';
import { OnboardingMachineContext } from 'components/onboarding/onboarding.machine';
import { useIsOnboardingMobile } from 'hooks/use-is-onboarding-mobile/use-is-onboarding-mobile.hook';
import { usePlanSwitcherRetry } from 'hooks/use-plan-switcher-retry/use-plan-switcher-retry.hook';

// Server-driven "Plan details not found" screen (GEIS-621), shown for both the
// `no_plans` and failed-closed `error` bootstrap signals.
export const PlanSwitcherErrorView = () => {
  const { formatMessage } = useIntl();
  const { send } = OnboardingMachineContext.useActorRef();
  const isOnboardingMobile = useIsOnboardingMobile();

  const handleRetry = useCallback(() => {
    send({ type: 'retry' });
  }, [send]);

  usePlanSwitcherRetry(handleRetry);
  usePageViewAnalytics({ screen_name: 'Plan Details Not Found' });
  useDocumentTitle(formatMessage({ id: 'STR_YOUR_PLANS' }));

  return (
    <OnboardingCard
      css={{
        // The card owns the whole gutter now that the surface behind it goes
        // edge-to-edge on mobile. $oneAndHalf there keeps the content inset
        // exactly where it was when the surface supplied that padding instead.
        padding: isOnboardingMobile ? '$oneAndHalf' : '$twoAndHalf',
        // ImageMessage reserves a gap under the image for children the Masonry
        // renderer never passes, stacking on the layout's own spacing.
        '.GDS-image-message > div': { marginBlockEnd: 0 },
      }}
    >
      <Masonry rootNodeId={MASONRY.ROOT_NODE_ID_PLAN_SWITCHER_ERROR} />
    </OnboardingCard>
  );
};
